// Welcome-offer pop-up: opens after a delay or once the visitor has scrolled
// through part of the page, never on arrival. Remembers dismissals (14 days)
// and subscriptions (permanently) in localStorage so it is not shown again.
const STORAGE_KEY = 'ps-signup-popup';
const DISMISS_DAYS = 14;

class SSignupPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    // Never open inside the editor or any embedded preview: a modal locks page scrolling.
    let embedded = false;
    try {
      embedded = window.self !== window.top;
    } catch {
      embedded = true;
    }
    if (window.Shopify?.designMode || embedded) return;

    this.handleScroll = this.handleScroll.bind(this);
    this.dialog.addEventListener('close', () => {
      if (!this.state) this.remember('dismissed');
      window.psSignupPopup = 'closed';
      document.dispatchEvent(new CustomEvent('ps:signup-popup-closed'));
    });
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    const params = new URLSearchParams(window.location.search);
    const returnedFromForm = window.location.hash === `#${this.dataset.formId}`;
    if (returnedFromForm) {
      if (params.get('customer_posted') === 'true') this.showSuccess();
      this.open();
      return;
    }

    if (this.hasSeen() && !params.has('popups')) {
      window.psSignupPopup = 'skipped';
      document.dispatchEvent(new CustomEvent('ps:signup-popup-skipped'));
      return;
    }
    this.timer = setTimeout(() => this.open(), Number(this.dataset.delay) || 20000);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= (Number(this.dataset.scroll) || 0.4)) this.open();
  }

  showSuccess() {
    this.querySelector('[data-signup-form]')?.setAttribute('hidden', '');
    this.querySelector('[data-signup-success]')?.removeAttribute('hidden');
    this.remember('subscribed');
  }

  hasSeen() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved) return false;
      if (saved.state === 'subscribed') return true;
      return Date.now() - saved.time < DISMISS_DAYS * 86400000;
    } catch {
      return false;
    }
  }

  remember(state) {
    this.state = state;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ state, time: Date.now() }));
    } catch {
      // Storage unavailable (private mode); the pop-up may show again next visit.
    }
  }

  open() {
    clearTimeout(this.timer);
    window.removeEventListener('scroll', this.handleScroll);
    if (this.dialog.open || document.querySelector('dialog[open]')) return;
    this.dialog.showModal();
  }
}

if (!customElements.get('s-signup-popup')) customElements.define('s-signup-popup', SSignupPopup);
